import React from 'react';
 
const Certificates = () => {
    return (
        <div id="certificates" className="pre-certificates-container">
            
            <div className="certificates-container">

                <div className="certificates">

                    <h1>My Certificates</h1>
                    <div className="certificates-wrapper">
                        <iframe src="https://drive.google.com/file/d/17C-nZHRxqLOoKNPgum_DK6NcoD6xb5Rh/preview" allow="autoplay"></iframe>
                        <a href="https://www.coursera.org/account/accomplishments/verify/8QQ6VN7M9K4P" target="_blank" rel="noreferrer">Verify</a>
                    </div>

                </div>

            </div>

        </div>
    )
}
 
export default Certificates;